module.exports = __webpack_public_path__ + "img/矢量智能对象(5).d9303265.png";